export default __webpack_public_path__ + "static/platform-9d3acba16c6211cfa70084c3e13c1737.png";